var React = require('react');

function Location (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12,8c-2.2,0-4,1.8-4,4s1.8,4,4,4s4-1.8,4-4S14.2,8,12,8z M20.9,11c-0.5-4.2-3.8-7.5-7.9-7.9V1h-2v2.1\n\t\tC6.8,3.5,3.5,6.8,3.1,11H1v2h2.1c0.5,4.2,3.8,7.5,7.9,7.9V23h2v-2.1c4.2-0.5,7.5-3.8,7.9-7.9H23v-2C23,11,20.9,11,20.9,11z M12,19\n\t\tc-3.9,0-7-3.1-7-7s3.1-7,7-7s7,3.1,7,7S15.9,19,12,19z"}));
}

Location.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Location;

Location.default = Location;
